export default __webpack_public_path__ + "e7318819c6108383f8a9062b1dbdbb00.svg";